import { useEffect, useState } from 'react';
import {
  Backdrop,
  Box,
  CircularProgress,
  Collapse,
  FormControl,
  Grid,
  InputBase,
  InputLabel,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';

import { isEmpty } from '../../library/utils';

import inputStyles from './inputStyles';

const StyledSelect = (props) => {
  const {
    id,
    label,
    defaultValue,
    noSelectedValue,
    value,
    options = [],
    handleChange,
    formControlClassName,
    selectClasses,
    selectNoPaddingLeft,
    // inputLabelTypographyStyle,
    listItemIconClasses,
    listItemTextTypographyStyle,
    formControlVariant,
    noLabel,
    noFormControl,
    boxComponent,
    boxSx,
    noBottomMargin,
    listItemTextSx,
    fullWidth,
    listItemIcon,
    endComponent,
    required,
    disabled,
    error,
    errorMessage,
    helperText,
    isLoading,
    noOutline,
    touched,
  } = props;
  const styles = inputStyles();

  const [onBlur, setOnBlur] = useState(!!touched);

  useEffect(() => {
    setOnBlur(!!touched);
  }, [touched]);

  const selectProps = {
    id,
    value:
      (!isEmpty(options) && options.find((o) => o.value === value) && value) ||
      (!isEmpty(options) && options[0].value) ||
      '',
    onChange: handleChange,
    classes: selectClasses || {
      select: selectNoPaddingLeft
        ? styles.selectRootNoPaddingLeft
        : styles.selectRoot,
    },
    fullWidth,
    disabled: disabled || isLoading,
  };

  if (selectProps.value === undefined || selectProps.value === null) {
    selectProps.defaultValue =
      defaultValue || (!isEmpty(options) && options[0].value) || '';
  }

  if (noOutline) {
    selectProps.sx = { borderWidth: '0 !important' };
  }

  const selectComponent = (
    <Select
      {...selectProps}
      onClose={() => setOnBlur(true)}
      input={<InputBase classes={{ root: styles.selectInputBase }} />}
    >
      {options.map((o, index) => (
        <MenuItem key={id + '-' + index} value={o.value}>
          {listItemIcon && (
            <ListItemIcon
              classes={listItemIconClasses || { root: styles.listItemIconRoot }}
            >
              {o.listItemIcon}
            </ListItemIcon>
          )}
          <ListItemText
            primary={
              <Typography style={listItemTextTypographyStyle}>
                {o.display}
              </Typography>
            }
            sx={listItemTextSx}
          />
        </MenuItem>
      ))}
    </Select>
  );

  return (
    <Box component={boxComponent} sx={boxSx} mb={noBottomMargin ? 0 : 1}>
      {!noLabel && (
        <InputLabel
          required={required}
          sx={{
            '& .MuiInputLabel-asterisk': {
              color: 'red',
            },
          }}
        >
          {label}
        </InputLabel>
      )}
      <div style={{ position: 'relative' }}>
        <Grid
          container
          direction="row"
          display="flex"
          alignItems="center"
          justifyContent="flex-start"
        >
          <div style={{ flexGrow: 1 }}>
            {noFormControl ? (
              selectComponent
            ) : (
              <FormControl
                fullWidth={fullWidth}
                variant={formControlVariant}
                className={formControlClassName || styles.formControlClass}
              >
                {selectComponent}
              </FormControl>
            )}
          </div>
          {endComponent}
        </Grid>
        {helperText && (
          <InputLabel>
            <Typography fontSize="0.7rem">{helperText}</Typography>
          </InputLabel>
        )}
        <Collapse
          in={
            error ||
            (required && (!value || value === noSelectedValue) && onBlur)
          }
        >
          <InputLabel>
            <Typography fontSize="0.7rem" color="red">
              {errorMessage ||
                (required &&
                  (!value || value === noSelectedValue) &&
                  onBlur &&
                  `${label} is required.`)}
            </Typography>
          </InputLabel>
        </Collapse>
        <StyledEngineProvider injectFirst>
          <Backdrop
            classes={{ root: styles.backdrop }}
            style={{ position: 'absolute', backgroundColor: 'transparent' }}
            open={isLoading || false}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </StyledEngineProvider>
      </div>
    </Box>
  );
};

export default StyledSelect;
